import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useErrorNotification } from "./useErrorNotification";

interface DownloadFileOptions {
    applicationType: string;
    filename: string;
    resource: Uint8Array;
}

export const useDownloadFile = () => {
    const { showTextMessage } = useErrorNotification();
    const { t } = useTranslation();

    return useCallback(
        async (options: DownloadFileOptions) => {
            const { applicationType, filename, resource } = options;

            try {
                const blob = new Blob([new Uint8Array(resource).buffer], {
                    type: applicationType,
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch {
                showTextMessage(t("errors.downloadFile"));
            }
        },
        [showTextMessage, t],
    );
};
